import React from 'react';
import { Flex, Icon, Box, DataList, DataItem } from '@cad-arc';
import { LinkText } from '../../../../../common/components/link-text';
import { EventDetailsTabView, FieldNameEnum } from '@mark43/cad-api';
import { useOpenDepartmentLink } from '../../../../../layout/use-open-department-link';
import { useBootstrapState } from '../../../../../bootstrap/bootstrap-provider';
import { useDisplayReportingEventNumbers } from '../../../../../common/hooks/use-display-reporting-event-numbers';
import { FR_EVENT_DETAILS_TABS } from '../../../../../fr-event-details-page/constants';
import { useOpenEvent } from '../../../../../common/hooks/use-open-event';

export function MergedEventNumbersList(props: {
    reportingEventNumbers: EventDetailsTabView['reportingEventNumbers'];
}): React.ReactElement {
    const openDepartmentLink = useOpenDepartmentLink();
    const openEventHandler = useOpenEvent();

    const { fieldDisplayNameByFieldName } = useBootstrapState();
    const renDisplayName =
        fieldDisplayNameByFieldName[FieldNameEnum.AGENCY_EVENT_REPORTING_EVENT_NUMBER.name];
    const displayReportingEventNumbers = useDisplayReportingEventNumbers(
        props.reportingEventNumbers
    );

    return (
        <DataList>
            {displayReportingEventNumbers.map((reportingEventNumber) => {
                const rmsSearchLink = reportingEventNumber.searchRmsLink;
                const eventId = reportingEventNumber.reportingEventId;

                return (
                    <Flex key={reportingEventNumber.id}>
                        <Box mr={1}>
                            <Icon icon="Merge" />
                        </Box>
                        <DataList>
                            <DataItem dataKey="Event #">
                                <LinkText
                                    onClick={() =>
                                        openEventHandler({
                                            eventId,
                                            frEventDetailsTabName: FR_EVENT_DETAILS_TABS.EVENT_INFO,
                                        })
                                    }
                                >
                                    {reportingEventNumber.agencyEventNumber}
                                </LinkText>
                            </DataItem>

                            <DataItem dataKey={renDisplayName}>
                                {rmsSearchLink ? (
                                    <LinkText
                                        onClick={() =>
                                            openDepartmentLink({
                                                tenantStrategy: 'PREFER_RMS_TENANT',
                                                path: rmsSearchLink,
                                                app: 'RMS',
                                            })
                                        }
                                    >
                                        {reportingEventNumber.display}
                                    </LinkText>
                                ) : (
                                    reportingEventNumber.display
                                )}
                            </DataItem>
                        </DataList>
                    </Flex>
                );
            })}
        </DataList>
    );
}
